import { z } from 'zod';

export const externalIdSchema = z.object({
  id: z.string(),
});
